import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Quiz from "./pages/Quiz";
import Result from "./pages/Result";
import ReportLow from "./pages/ReportLow";
import ReportMid from "./pages/ReportMid";
import ReportHigh from "./pages/ReportHigh";
import ThankYou from "./pages/ThankYou";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiePolicy from "./pages/CookiePolicy";
import Auth from "./pages/Auth";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";
import SocialSellingLanding from "./pages/SocialSellingLanding";
import SecuredReport from "./pages/SecuredReport";
import SocialSellingAudit from "./pages/SocialSellingAudit";
import SocialSellingThankYou from "./pages/SocialSellingThankYou";
import SocialSellingStatus from "./pages/SocialSellingStatus";
import SocialSellingReport from "./pages/SocialSellingReport";
import CampaignRedirect from "./pages/CampaignRedirect";
import FileDownload from "./pages/FileDownload";
import LandingPage from "./pages/LandingPage";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/c/:campaignTag" element={<CampaignRedirect />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/wynik" element={<Result />} />
          <Route path="/raport-low" element={<ReportLow />} />
          <Route path="/raport-mid" element={<ReportMid />} />
          <Route path="/raport-high" element={<ReportHigh />} />
          <Route path="/dziekujemy" element={<ThankYou />} />
          <Route path="/polityka-prywatnosci" element={<PrivacyPolicy />} />
          <Route path="/regulamin" element={<TermsOfService />} />
          <Route path="/polityka-cookies" element={<CookiePolicy />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/social-selling-audyt" element={<SocialSellingLanding />} />
          <Route path="/raport-socialselling" element={<SocialSellingAudit />} />
          <Route path="/raport-socialselling/status/:id" element={<SocialSellingStatus />} />
          <Route path="/raport-socialselling/raport/:id" element={<SocialSellingReport />} />
          <Route path="/raport-socialselling/thankyou" element={<SocialSellingThankYou />} />
          <Route path="/linkedin-entry-score/:reportToken" element={<SecuredReport />} />
          <Route path="/raport-zabezpieczony/:reportToken" element={<SecuredReport />} />
          <Route path="/s/:slug" element={<FileDownload />} />
          <Route path="/l/:slug" element={<LandingPage />} />
          <Route path="/l/:slug/:action" element={<LandingPage />} />
          
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
